import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import './LinksSlide.css'

class ImageSlide extends Slide {

    render() {

        const nodes = this.props.links.map((link, index, { length }) => (
            <React.Fragment>
                <a href={link.href}>{ link.text }</a>{ index === length - 1 ? '.' : index === length - 2 ? ', and ' : ', ' }  
            </React.Fragment>
        ))


        return super.render(
            <div className='LinksSlide'>
                { this.props.text }
                <span>{ nodes }</span>
                <img src={this.props.img} />
            </div>
        )
    }
}
 
ImageSlide.propTypes = {
    text: PropTypes.string.isRequired,
    links: PropTypes.array.isRequired,
    img: PropTypes.string.isRequired
}

export default ImageSlide;



// WEBPACK FOOTER //
// ./src/components/LinksSlide.js